import React, { useState } from 'react';
import { Flex, Form, Modal, Select, Input, Button } from 'antd';
import { CheckIcon } from '@heroicons/react/20/solid';
import { NETWORK_TYPES, TOKEN_TYPES } from 'features/bill/lib';
import { NetworkLabel } from 'widgets/Invoices/InvoiceGenerateForm.PaymentTypeSelection';
import { CurrencyIcon } from 'features/payments/CurrencyIcon';

export const SourceSelection: React.FC<{
  onSelect?: ({
    sourceNetwork,
    sourceToken,
  }: {
    sourceNetwork: string;
    sourceToken: string;
  }) => void;
}> = ({ onSelect }) => {
  const [form] = Form.useForm();

  const handleSubmit = (values: {
    sourceNetwork: string;
    sourceToken: string;
  }) => {
    onSelect({
      sourceNetwork: values.sourceNetwork,
      sourceToken: values.sourceToken,
    });
  };
  return (
    <div className="absolute left-0 top-0 z-30 p-6 flex h-full w-full rounded-lg bg-slate-800">
      <Form
        className="h-full w-full flex flex-col"
        requiredMark={false}
        form={form}
        onFinish={handleSubmit}>
        <h3 className="text-lg mb-4 pr-8 text-slate-300">
          Please select the network and token you would like to use for your
          deposit
        </h3>

        <Form.Item
          name="sourceNetwork"
          layout="vertical"
          className="h-[62px]"
          label="Source network"
          rules={[{ required: true, message: 'Please select value' }]}>
          <Select
            placeholder={'Choose source network'}
            options={[
              NETWORK_TYPES.Ethereum,
              NETWORK_TYPES.Polygon,
              NETWORK_TYPES.Solana,
              NETWORK_TYPES.Tron,
            ].map((n) => ({
              value: n,
              label: <NetworkLabel network={n} />,
            }))}
          />
        </Form.Item>

        <Form.Item
          name="sourceToken"
          layout="vertical"
          className="h-[62px]"
          label="Source token"
          rules={[{ required: true, message: 'Please select value' }]}>
          <Select
            placeholder={'Choose source token'}
            options={[TOKEN_TYPES.USDC, TOKEN_TYPES.USDT].map((c) => ({
              value: c,
              label: (
                <Flex align={'center'} gap={'small'}>
                  <CurrencyIcon currency={c} />
                  {c}
                </Flex>
              ),
            }))}
          />
        </Form.Item>

        <div className="flex-1" />
        <Button
          size="large"
          type="primary"
          htmlType="submit"
          className="bg-indigo-600 w-[100%] hover:!bg-indigo-500"
          icon={<CheckIcon className="w-4" />}>
          Confirm
        </Button>
      </Form>
    </div>
  );
};
